import { Typography } from "@mui/material";
import styled from "styled-components";

export const StyledNumbers = styled(Typography)(() => ({
  color: "#424242",
  textAlign: "center",
  fontSize: "25px",
  fontStyle: "bold",
  fontWeight: "400",
  lineHeight: "38px"
}));
